const isAuthenticated = () => !!localStorage.token;

export default isAuthenticated;
